import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { clearExpensesList } from "../../../state/ducks/member/index";
import NumberFormat from "react-number-format";
import $ from "jquery";
import { createPaymentPages } from "../../../state/ducks/payment/types";
import {
  EminPayInfoModal,
  EminPayPageLayout,
  getEminPayTypeLabel,
} from "./EminPayPaymentUi";
import EminPayServiceAlert from "./EminPayServiceAlert";
import EminPayCustomSelect from "./EminPayCustomSelect";
import { hideModal } from "../../../state/ducks/alert/index";

function uyeNoKontrol(memberNo) {
  const memberValue =
    memberNo != null
      ? String(memberNo)
      : document.getElementById("uyeno")?.getAttribute("data-value") || "0";
  let durum = 1;

  if (!memberValue || memberValue === "0") {
    durum = 0;
    $("#uyeno-wrap").addClass("t-error");
    $("#uyeno_status").html("<i class='t-icon-error text-danger'></i>");
    $("#uyeNo_hatamesaj").html("Üye Numarasını Seçmelisiniz");
  } else {
    $("#uyeno-wrap").removeClass("t-error");
    $("#uyeno_status").html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#uyeNo_hatamesaj").html("");
  }

  return durum;
}

function formKontrol() {
  const ucretLira = $("#ucretLira").val();
  let durum = 1;

  if (ucretLira === "") {
    durum = 0;
    $("#ucretLira").parent().addClass("t-error");
    $("#ucretKrs").next().html("<i class='t-icon-error text-danger'></i>");
    $("#ucretLira_hatamesaj").html("Bu alan boş bırakılamaz");
  } else {
    $("#ucretLira").parent().removeClass("t-error");
    $("#ucretKrs").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#ucretLira_hatamesaj").html("");
  }

  return durum;
}

export class OrderDetailEminPay extends Component {
  state = {
    memberNo: "0",
    startDate: new Date(),
    aylikTutar: "",
    aylikTutarOndalik: 0,
    installmentCount: "",
    getMemberExpense: {},
    shouldAnimateCard: false,
    showAmountInfoModal: false,
    showSapWarningModal: false,
  };

  componentDidMount() {
    this._isMounted = true;

    if (this.props.orderdetail.memberNo === "0") {
      this.props.clearExpensesList();
    } else {
      this.setState({ memberNo: this.props.orderdetail.memberNo });
    }

    this.setState({ shouldAnimateCard: true });
    this.animateCardTimeoutId = window.setTimeout(() => {
      if (this._isMounted) {
        this.setState({ shouldAnimateCard: false });
      }
    }, 900);
  }

  componentWillUnmount() {
    this._isMounted = false;

    if (this.animateCardTimeoutId) {
      window.clearTimeout(this.animateCardTimeoutId);
    }
  }

  onSubmit = (event) => {
    event.preventDefault();
    const { orderdetail, expenses } = this.props;

    if (formKontrol() === 0 || uyeNoKontrol(orderdetail.memberNo) === 0) {
      return false;
    }

    if (expenses.message != null) {
      $("#uyeno-wrap").addClass("t-error");
      $("#uyeno_status").html("<i class='t-icon-error text-danger'></i>");
      $("#uyeNo_hatamesaj").html(expenses.message);
      return false;
    }

    $("#uyeno-wrap").removeClass("t-error");
    $("#uyeno_status").html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#uyeNo_hatamesaj").html("");

    if (!expenses.sapSozlesmeNo) {
      this.setState({ showSapWarningModal: true });
      return false;
    }

    const { payment } = this.props;

    if (
      this.calcPaymentControl(
        orderdetail.aylikTutar,
        orderdetail.aylikTutarOndalik,
        expenses.kalanTutarToplam,
        payment.paymentSumData
      )
    ) {
      orderdetail.startDate = this.state.startDate;
      this.props.changePage(createPaymentPages.creditCard);
      this.setState({ getMemberExpense: expenses });
    }

    return false;
  };

  calcPaymentControl = (
    girilenTutar,
    girilenTutarOndalik,
    orgUcretiKalanToplamBorc,
    bekleyenTalimatToplamTutar
  ) => {
    const total =
      parseFloat(`${girilenTutar}.${girilenTutarOndalik}`) +
      parseFloat(bekleyenTalimatToplamTutar || 0);

    if (orgUcretiKalanToplamBorc >= total) {
      return true;
    }

    this.setState({ showAmountInfoModal: true });
    return false;
  };

  processRun = (memberNo) => {
    if (uyeNoKontrol(memberNo) === 1) {
      this.props.clearServiceAlert();
      const { orderdetail } = this.props;
      this.props.loadMemberPaymentData(memberNo, orderdetail.paymentType);
    }
  };

  renderExpenseAmount = (value) => (
    <NumberFormat decimalSeparator="," thousandSeparator="." value={value} displayType="text" />
  );

  renderExpensesTable = (expenses) => {
    const list = expenses?.list || [];
    const totalTutar = list.reduce((acc, x) => acc + Number(x.tutar), 0);
    const totalKalan = list.reduce((acc, x) => acc + Number(x.kalanTutar), 0);

    return (
      <>
        <div className="t-myDemands-desktopOnly t-listPayments-tableWrap t-eminPayOrder-tableWrap">
          <table className="t-listPayments-table t-eminPayOrder-table">
            <thead>
              <tr>
                <th scope="col">Tür</th>
                <th scope="col">Vade Tarihi</th>
                <th scope="col">Tutar</th>
                <th scope="col">Kalan</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr
                  key={`${item.tur}_${item.vadeTarihi}_${index}`}
                  className={item.kalanTutar === 0 ? "t-eminPayOrder-rowPaid" : ""}
                  data-due={item.vadesiGelmisMi ? "due" : "future"}
                >
                  <td>{item.tur}</td>
                  <td>{item.vadeTarihi}</td>
                  <td>{this.renderExpenseAmount(item.tutar)}</td>
                  <td>{this.renderExpenseAmount(item.kalanTutar)}</td>
                </tr>
              ))}
              <tr className="t-eminPayOrder-totalRow">
                <td />
                <td>Toplam</td>
                <td>{this.renderExpenseAmount(totalTutar)}</td>
                <td>{this.renderExpenseAmount(totalKalan)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="t-myDemands-mobileOnly t-myDemands-mobileList t-eminPayOrder-expensesMobileList">
          {list.map((item, index) => (
            <article
              key={`${item.tur}_${item.vadeTarihi}_${index}`}
              className={`t-myDemands-mobileCard t-eminPayOrder-expenseCard${
                item.kalanTutar === 0 ? " t-eminPayOrder-expenseCard--paid" : ""
              }`}
              data-due={item.vadesiGelmisMi ? "due" : "future"}
            >
              <div className="t-myDemands-mobileField">
                <span className="t-myDemands-mobileLabel">Tür</span>
                <span className="t-myDemands-mobileValue">{item.tur || "-"}</span>
              </div>
              <div className="t-myDemands-mobileField">
                <span className="t-myDemands-mobileLabel">Vade Tarihi</span>
                <span className="t-myDemands-mobileValue">{item.vadeTarihi || "-"}</span>
              </div>
              <div className="t-myDemands-mobileField">
                <span className="t-myDemands-mobileLabel">Tutar</span>
                <span className="t-myDemands-mobileValue">{this.renderExpenseAmount(item.tutar)} ₺</span>
              </div>
              <div className="t-myDemands-mobileField">
                <span className="t-myDemands-mobileLabel">Kalan</span>
                <span className="t-myDemands-mobileValue">{this.renderExpenseAmount(item.kalanTutar)} ₺</span>
              </div>
            </article>
          ))}

          <article className="t-myDemands-mobileCard t-eminPayOrder-expenseCard t-eminPayOrder-expenseCard--total">
            <div className="t-myDemands-mobileField">
              <span className="t-myDemands-mobileLabel">Toplam Tutar</span>
              <span className="t-myDemands-mobileValue">{this.renderExpenseAmount(totalTutar)} ₺</span>
            </div>
            <div className="t-myDemands-mobileField">
              <span className="t-myDemands-mobileLabel">Toplam Kalan</span>
              <span className="t-myDemands-mobileValue">{this.renderExpenseAmount(totalKalan)} ₺</span>
            </div>
          </article>
        </div>
      </>
    );
  };

  render() {
    const { payment, orderdetail, expenses } = this.props;
    const { shouldAnimateCard, showAmountInfoModal, showSapWarningModal } = this.state;

    if (!(orderdetail.startDate instanceof Date) && orderdetail.startDate != null) {
      const startDateArr = orderdetail.startDate.split(".");
      const date = new Date(startDateArr[2], startDateArr[1] - 1, startDateArr[0]);
      orderdetail.startDate = date;
      this.setState({ startDate: date });
    }

    const krediKartsizTaksitliOrgMi = expenses?.list?.some((x) => x.vadesiGelmisMi === false);

    return (
      <>
        <EminPayPageLayout
          pageSubtitle='Kredi kartıyla talimatlar yalnızca "organizasyon ücreti" tutarı kadar girilebilir.'
          cardTitle="Ödeme Bilgileri"
          stepBadge="Adım 2 / 4"
          paymentTypeLabel={getEminPayTypeLabel(orderdetail.paymentType)}
          activeStep={1}
          shouldAnimateCard={shouldAnimateCard}
        >
          <form className="t-resetPassword-form t-eminPayOrder-form" onSubmit={this.onSubmit} noValidate>
            <EminPayServiceAlert inline />
            <div className="t-resetPassword-field">
              <label htmlFor="uyeno" className="t-resetPassword-label">
                Üye Numarası
              </label>
              <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap" id="uyeno-wrap">
                <span className="t-resetPassword-inputIcon" aria-hidden="true">
                  <i className="t-icon-user1" />
                </span>
                <EminPayCustomSelect
                  id="uyeno"
                  value={orderdetail.memberNo}
                  placeholder="Üye numarası seçiniz"
                  options={[
                    { value: "0", label: "Üye numarası seçiniz" },
                    ...(payment?.paymentActiveMemberNoListData?.map((item) => ({
                      value: String(item.id),
                      label: item.adi,
                    })) || []),
                  ]}
                  onChange={(nextValue) => {
                    this.props.clearExpensesList();
                    orderdetail.memberNo = nextValue;
                    this.setState({ memberNo: nextValue });

                    if (nextValue === "0") {
                      this.props.clearExpensesList();
                    } else {
                      this.props.clearServiceAlert();
                      this.processRun(nextValue);
                    }
                  }}
                />
                <span className="t-eminPayFieldStatus" id="uyeno_status" aria-hidden="true" />
              </div>
              <div className="t-resetPassword-error" id="uyeNo_hatamesaj" />
            </div>

            <div className="t-resetPassword-field">
              <label htmlFor="ucretLira" className="t-resetPassword-label">
                Organizasyon Ücreti Talimat Tutarı
              </label>
              <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
                <span className="t-resetPassword-inputIcon" aria-hidden="true">
                  <strong>₺</strong>
                </span>
                <NumberFormat
                  displayType="input"
                  required
                  value={orderdetail.aylikTutar}
                  maxLength="10"
                  id="ucretLira"
                  className="sayi inputpara"
                  decimalSeparator={false}
                  thousandSeparator="."
                  onChange={(event) => {
                    orderdetail.aylikTutar = event.target.value.trim().replace(/\./g, "");
                    this.setState({ aylikTutar: event.target.value.trim().replace(/\./g, "") });
                  }}
                />
                <span className="t-eminPayOrder-decimalSep">,</span>
                <NumberFormat
                  displayType="input"
                  className="sayimax2 t-eminPayOrder-decimalInput"
                  required
                  value={orderdetail.aylikTutarOndalik}
                  placeholder="00"
                  maxLength="2"
                  id="ucretKrs"
                  allowLeadingZeros
                  decimalSeparator={false}
                  allowNegative={false}
                  onChange={(event) => {
                    orderdetail.aylikTutarOndalik = event.target.value.trim();
                    this.setState({ aylikTutarOndalik: event.target.value.trim() });
                  }}
                />
              </div>
              <div className="t-resetPassword-error" id="ucretLira_hatamesaj" />
            </div>

            {orderdetail.memberNo && orderdetail.memberNo !== "0" && (
              <div className="t-eminPayOrder-notice">
                {krediKartsizTaksitliOrgMi ? "Bu dönem " : ""}
                Kredi kartı ile ödeyebileceğiniz maksimum tutar:{" "}
                <strong>
                  <NumberFormat
                    decimalSeparator=","
                    thousandSeparator="."
                    value={expenses.kalanTutarToplam ?? 0}
                    displayType="text"
                  />{" "}
                  ₺
                </strong>
              </div>
            )}

            {expenses?.list?.length > 0 && this.renderExpensesTable(expenses)}

            <div className="t-eminPayOrder-formActions">
              <Link
                to={{
                  pathname: "/Home/CreatePayment",
                  state: { paymentType: orderdetail.paymentType },
                }}
                className="t-memberInfo-btn t-memberInfo-btn--secondary"
              >
                <i className="t-icon-arrow-left2" aria-hidden="true" />
                <span>Geri</span>
              </Link>
              <button type="submit" className="t-memberInfo-btn t-memberInfo-btn--primary">
                <span>Devam</span>
                <i className="t-icon-arrow-right2" aria-hidden="true" />
              </button>
            </div>
          </form>
        </EminPayPageLayout>

        <EminPayInfoModal
          show={showAmountInfoModal}
          title="Talimat Tutarı"
          onClose={() => this.setState({ showAmountInfoModal: false })}
        >
          <p>Girmiş olduğunuz talimat tutarı, kalan organizasyon ücretinden büyük olamaz.</p>
          <p className="t-eminPayOrder-modalWarning">
            Lütfen önceden girilen talimatları kontrol ediniz. Başarısız talimat işleminiz varsa
            iptal edip tekrar talimat girmeyi deneyiniz.
          </p>
        </EminPayInfoModal>

        <EminPayInfoModal
          show={showSapWarningModal}
          title="Ödeme Talimatı Girilemez"
          onClose={() => this.setState({ showSapWarningModal: false })}
        >
          <p className="t-eminPayOrder-modalWarning">
            İlgili üyelik özelinde SAP sözleşme numaranız henüz oluşmadığı için ödeme talimatı
            girilemez. Lütfen müşteri temsilciniz ile iletişime geçiniz.
          </p>
        </EminPayInfoModal>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  clearExpensesList: () => dispatch(clearExpensesList()),
  clearServiceAlert: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(OrderDetailEminPay);
